import styled from 'styled-components';
import TvWithCableIconSvg from '../../assets/hotels/amenities/TvWithCable.svg';

const TvWithCableIcon = styled(TvWithCableIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TvWithCableIcon;
